import React, { Component } from "react";
import { getModelName } from "../utils/models";
import { get, on } from "../utils/sockets";
import custom from "../config/custom";
import _ from "lodash";
import store from "../store";

const itemsLimit = 300;

export default WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        fetching: false,
        items: props.items || []
      };
    }

    model() {
      return getModelName(this.props.model, this.props.attribute);
    }

    componentDidMount() {
      this.mounted = true;

      const modelName = this.model();

      on(modelName, msg => {
        if (this.mounted) {
          if (msg.verb === "created") {
            if (this.props.onlyNewItems) {
              if (
                !msg.data.createdBy ||
                msg.data.createdBy.id !== store.getState().auth.user.id
              ) {
                return;
              }
            }

            this.add(msg.data);
          }
        }
      });

      if (this.props.onlyNewItems) return;

      this.fetch();
    }

    componentDidUpdate(prevProps) {
      if (this.props.filter !== prevProps.filter) {
        this.fetch();
      }

      if (this.props.items !== prevProps.items) {
        this.setState({ items: this.props.items });
      }
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    getUrl() {
      const modelName = this.model();
      const url = `${custom.baseUrl}/${modelName}`;

      if (this.props.filter) {
        return `${url}?where=${JSON.stringify(
          this.props.filter,
          (key, value) => {
            if (value === undefined) {
              return null;
            }

            return value;
          }
        )}&offset=${itemsLimit}`;
      }

      return `${url}?limit=${itemsLimit}`;
    }

    fetch() {
      if (this.props.items) {
        return;
      }

      this.setState({ fetching: true });

      get(this.getUrl())
        .then(response => {
          this.setState({ items: response });
        })
        .catch((error) => {
        })
        .then(() => {
          this.setState({ fetching: false });
        });
    }

    add(data) {
      if (_.findIndex(this.state.items, { id: data.id }) === -1) {
        this.setState({
          items: [...this.state.items, data]
        });
      }

      if (this.props.onlyNewItems) {
        const currentValue =
          this.props.form.getFieldValue(this.props.attribute) || [];

        this.props.form.setFieldsValue({
          [this.props.attribute]: [...currentValue, data.id]
        });
      }
    }

    render() {
      return <WrappedComponent {...this.state} {...this.props} />;
    }
  };
};



// WEBPACK FOOTER //
// ./src/hocs/withItems.js